import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MaterialModule } from "../../core/shared/material.module";

/**
 * The `SummaryDataCardComponent` represents a reusable UI component for displaying summary data in a card format.
 * It provides functionalities for downloading associated data and emitting events when the card is selected or a download is triggered.
 */
@Component({
  selector: "app-summary-data-card",
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: "./summary-data-card.component.html",
  styleUrl: "./summary-data-card.component.scss",
})
export class SummaryDataCardComponent {
  @Input() item: any = {};
  @Output() onDownload = new EventEmitter<any>();
  @Output() onCardSelect = new EventEmitter<any>();

  /**
   * Triggers the download event and emits the provided URL or data.
   * @param url - The URL or data to be downloaded.
   */
  download(type: any) {
    this.onDownload.emit(type);
  }

  /**
   * Handles the card selection and emits the selected card's data.
   * @param item - The data or object representing the selected card.
   */
  onClickCard(item: any) {
    this.onCardSelect.emit(item);
  }

  expand(type:any){
    this.onCardSelect.emit(type);
  }
}
